function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M151.001,390.003v15c0,19.998,13.2,36.791,31.278,42.634c6.05,35.327,36.696,64.366,73.722,64.366 s67.672-29.039,73.722-64.366c18.078-5.843,31.278-22.635,31.278-42.634v-15H151.001z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M217.344,4.045C149.639,18.181,94.502,73.142,80.146,140.818c-12.202,57.583,2.857,115.386,41.294,158.599 c15.54,17.487,25.02,38.593,28.129,60.586h212.915c3.215-21.889,12.973-43.33,28.956-61.568 c28.74-32.769,45.561-74.839,45.561-118.433C437.001,65.821,331.274-19.94,217.344,4.045z M361.001,195.003 c-8.291,0-15-6.709-15-15c0-49.629-40.386-90-90.015-90c-8.291,0-15-6.709-15-15c0-8.291,6.709-15,15-15 c66.182,0,120.015,53.833,120.015,120C376.001,188.294,369.292,195.003,361.001,195.003z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M45.001,180.003h-30c-8.291,0-15,6.709-15,15c0,8.291,6.709,15,15,15h30c8.291,0,15-6.709,15-15 C60.001,186.712,53.292,180.003,45.001,180.003z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M51.212,105.003L30.001,83.792c-5.86-5.86-15.352-5.86-21.211,0c-5.859,5.859-5.859,15.352,0,21.211l21.211,21.211 c5.859,5.859,15.352,5.859,21.211,0C57.071,120.355,57.071,110.862,51.212,105.003z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M51.212,263.792c-5.859-5.859-15.352-5.86-21.211,0L8.79,285.003c-5.859,5.859-5.859,15.352,0,21.211 c5.859,5.859,15.352,5.859,21.211,0l21.211-21.211C57.071,279.144,57.071,269.651,51.212,263.792z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M497.001,180.003h-30c-8.291,0-15,6.709-15,15c0,8.291,6.709,15,15,15h30c8.291,0,15-6.709,15-15 C512.001,186.712,505.292,180.003,497.001,180.003z"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M503.212,83.792c-5.859-5.859-15.352-5.859-21.211,0l-21.211,21.211c-5.859,5.859-5.859,15.352,0,21.211 c5.859,5.859,15.351,5.859,21.211,0l21.211-21.211C509.071,99.144,509.071,89.651,503.212,83.792z"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M503.212,285.003l-21.211-21.211c-5.859-5.859-15.352-5.859-21.211,0s-5.859,15.352,0,21.211l21.211,21.211 c5.859,5.859,15.352,5.859,21.211,0S509.071,290.862,503.212,285.003z"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var SvgIdea = function SvgIdea(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.003 512.003",
    style: {
      enableBackground: "new 0 0 512.003 512.003"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIdea, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/idea.c9ab90d1.svg";
export { ForwardRef as ReactComponent };